export const getIdentificationType = (type: number) => {
  if (type === 1) return "Pasaporte";
  return "DNI";
};

export const getBusinessIdentificationType = (type: number) => {
  if (type === 1) return "CUIL";
  return "CUIT";
};
